<!-- Copyright 2022, Common Good Learning Tools LLC -->
<template><div class="k-hdcp-tree-item-outer">
	<div class="k-hdcp-tree-item-inner" 
		:class="(node.children.length>0)?'':'k-hdcp-tree-item-inner-branch'" 
		@click="node_clicked"
	>
		<k-icon v-if="show_radio" 
			class="k-hdcp-tree-item-selector-icon" 
			@click="selector_clicked"
		>{{node.selected ? 'fas fa-square-check' : 'far fa-square'}}</k-icon>

		<k-icon class="k-hdcp-tree-item-icon">{{icon}}</k-icon>

		<div v-if="cfitem.humanCodingScheme&&show_hcs_at_start" class="k-hdcp-tree-item-hcs-start">{{cfitem.humanCodingScheme}}</div>

		<k-hover v-slot:default="{hover}">
			<div class="k-hdcp-tree-item-statement" :style="node.selected?'font-weight:bold':''">
				{{career_title(cfitem.fullStatement)}}
				<span v-if="cfitem.humanCodingScheme && !show_hcs_at_start && hover" class="k-hdcp-tree-item-hcs-end">({{cfitem.humanCodingScheme}})</span>
			</div>
		</k-hover>
	</div>
	<k-expand-transition>
		<div v-if="node.children.length>0" v-show="node.open" class="k-hdcp-tree-item-children">
			<HDCPTreeItem v-for="(child_node) of node.children" :key="child_node.cfitem.identifier"
				:node="child_node"
				:icon_mappings="icon_mappings"
				:show_hcs_at_start="show_hcs_at_start" 
				:show_radio_for_type="show_radio_for_type" 
			/>
		</div>
	</k-expand-transition>
</div></template>

<script>
import { mapState, mapGetters } from 'vuex'
import HDCPTreeItem from './HDCPTreeItem'

export default {
	name: 'HDCPTreeItem',
	components: { HDCPTreeItem },
	props: {
		node: { type: Object, required: true },
		icon_mappings: { type: Object, required: true },
		show_hcs_at_start: { type: Boolean, required: true },
		show_radio_for_type: { type: String, required: true },
	},
	data() { return {
	}},
	computed: {
		...mapState([]),
		...mapGetters([]),
		cfitem() { return this.node.cfitem },
		show_radio() { 
			return this.node.cfitem.CFItemType == this.show_radio_for_type 
		},
		icon() {
			for (let item_type in this.icon_mappings) {
				if (this.cfitem.CFItemType == item_type) return this.icon_mappings[item_type]
			}
			if (this.node.children.length > 0) {
				if (this.node.open) return 'fas fa-chevron-circle-down'
				return 'fas fa-chevron-circle-right'
			}
			return 'fas fa-dot-circle'
		},
	},
	watch: {
	},
	created() {
	},
	mounted() {
	},
	methods: {
		career_title(s) { return vapp.hdcp_component.career_title(s) },

		node_clicked() {
			if (this.node.children.length > 0) {
				this.node.open = !this.node.open
			}
		},

		selector_clicked() {
			vapp.hdcp_component.node_selected(this.node)
		},
	}
}
</script>

<style lang="scss">
.k-hdcp-tree-item-outer {
}

.k-hdcp-tree-item-inner {
	display:flex;
	align-items: flex-start;
	font-size:17px;
	line-height:20px;
	margin:8px 0;
	cursor:pointer;
}

.k-hdcp-tree-item-inner-branch {
	margin:12px 0;
}

.k-hdcp-tree-item-selector-icon {
	font-size: 22px!important;
	margin-right:8px;
	margin-top:-2px;
	color:$v-green-darken-4!important;
}

.k-hdcp-tree-item-icon {
	font-size: 18px!important;
	margin-right:6px;
	color:#333!important;
}
.k-hdcp-tree-item-hcs-start {
	font-weight:bold;
	margin-right:6px;
	white-space:nowrap;
}
.k-hdcp-tree-item-hcs-end {
	font-style: italic;
	color:#999;
	font-size:12px;
	line-height:12px;
}
.k-hdcp-tree-item-statement {
	
}

.k-hdcp-tree-item-children {
	margin-left:24px;
}

</style>